import { useEffect, useState } from "react";
import { joiResolver } from "@hookform/resolvers/joi";
import { useForm } from "react-hook-form";
import schema from "../schema";
import { IGetUserPositionData } from "../../../../services/userPositionService/types";
import { ISubmissionPost } from "../SubmissionForm/types";
import { IGetGLAccountsData } from "../../../../services/trxCodeSetService";
import { IGetVendorAccountsData } from "../../../../services/vendorSetService";
import { IGetRedReceiptData } from "../../../../services/bmAgingService";
import { IGetTrxRedReceiptsData } from "../../../../services/trxRedReceiptService";

export interface RedReceiptType extends IGetRedReceiptData {
  ijirType: string,
  ijirExpiryDesc: string,
}

const useFormHook = (dataUser: Partial<IGetUserPositionData>) => {
  const [glAccount, setGlAccount] = useState<IGetGLAccountsData>();
  const [destinationAccount, setDestinationAccount] = useState<IGetVendorAccountsData>();
  const [redReceiptType, setRedReceiptType] = useState<RedReceiptType>();
  const [redReceiptNumber, setRedReceiptNumber] = useState<IGetTrxRedReceiptsData>();

  const initialValueCharge = {
    employeeNip: dataUser.employee_id,
    employeeName: dataUser.employee_name,
    jobTitle: dataUser.job_title,
    jobId: dataUser.job_id,
  };

  const methods = useForm<ISubmissionPost>({
    defaultValues: initialValueCharge,
    resolver: joiResolver(schema),
  });

  const { setValue, watch } = methods;

  useEffect(() => {
    if (glAccount) setValue("trxCode", glAccount.trx_code, { shouldValidate: true });
    else setValue("trxCode", "");
  }, [glAccount]);
  useEffect(() => {
    if (destinationAccount) setValue("beneficiaryCode", destinationAccount.vendor_code, { shouldValidate: true });
    else setValue("beneficiaryCode", "");
  }, [destinationAccount]);
  useEffect(() => {
    if (redReceiptNumber) {
      setValue("redReceiptNumber", redReceiptNumber.trx_id_bm, { shouldValidate: true });
      setValue("beneficiaryCode", "VDR2024072900001", { shouldValidate: true });
    } else {
      setValue("redReceiptNumber", "");
      setValue("beneficiaryCode", "");
    }
  }, [redReceiptNumber]);
  useEffect(() => {
    if (redReceiptType) setValue("redReceiptType", { label: redReceiptType.bm_type, value: redReceiptType.bm_type }, { shouldValidate: true });
    else setValue("redReceiptType", { label: "", value: "" });
  }, [redReceiptType]);

  useEffect(() => {
    setGlAccount(undefined);
    setDestinationAccount(undefined);
    setRedReceiptNumber(undefined);
    setRedReceiptType(undefined);
  }, [watch("trxType")]);

  return {
    glAccount,
    setGlAccount,
    destinationAccount,
    setDestinationAccount,
    redReceiptType,
    setRedReceiptType,
    redReceiptNumber,
    setRedReceiptNumber,
    initialValueCharge,
    methods,
  };
};

export default useFormHook;
